
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'tFooterInfo',
})
export default class extends Vue {
  private selectedLink = '';

  private siteLinks: any = [
    { label: '국민고향 남해', value: 'https://www.namhae.go.kr/tour/01015/01036.web' },
    { label: '남해문화관광', value: 'https://www.namhae.go.kr/tour/main.web' },
    { label: '남해관광문화재단', value: 'https://www.namhaetour.org' },
    { label: '구석구석 남해', value: 'https://visitnamhae.co.kr' },
    { label: '남해로온', value: 'https://namhaeon.com' },
  ];

  private handleLinkChange(value: string) {
    if (value) {
      window.open(value, '_blank');
      // 선택 후 초기화
      this.selectedLink = '';
    }
  }
}
